import B2BCustomersTable from '@/containers/B2BCustomers/B2BCustomers'
import Orders from '@/containers/Orders/Orders'
import CustomerGroups from '@/containers/CustomerGroups/CustomerGroups'
import Fabrics from '@/containers/Fabrics/Fabrics'
import FabricPalettes from '@/containers/FabricPalettes/FabricPalettes'
import PriceLists from '@/containers/PriceLists/PriceLists'
import PriceListDetails from '@/containers/PriceLists/components/PriceListDetails'
import Members from '@/containers/Organisation/Members'
import Organization from '@/containers/Organisation/Organization'
import Settings from '@/containers/Settings/Settings'
import Translations from '@/containers/Settings/Emails'
import LoginAttempts from '@/containers/Settings/LoginAttempts'
import LanguageSettings from '@/containers/Settings/LanguageSettings'
import UISettings from '@/containers/Settings/UISettings'
import AdminSettings from '@/containers/Settings/AdminSettings'
import ProductCatalog from '@/containers/Products/ProductCatalog'
import Tags from '@/containers/Tags/Tags'
import Categories from '@/containers/Categories/Categories'
import Collections from '@/containers/Collections/Collections'
import ContentBlocks from '@/containers/ContentBlocks/ContentBlocks'
import { AccountManagers } from '@/containers/AccountManagers/AccountManagers'
import AdditionalComponentGroups from '@/containers/AdditionalComponentGroups/AdditionalComponentGroups'
import CustomerAccounts from '@/containers/CustomerAccounts/CustomerAccounts'
import ProductFeatures from '@/containers/ProductFeatures/ProductFeatures'
import { NavItem, SidebarNavItem } from '@/types'
import { ProductDetails } from '@/containers/Products/components/ProductDetails'
import B2BAccountOrdersPage from '@/containers/B2BCustomers/[accountId]/orders/page'
import OrderDetails from '@/containers/Orders/components/OrderDetails'

export enum UserRole {
  ADMIN = 'ADMIN',
  USER = 'USER',
  GUEST = 'GUEST',
}

export const sidebarLinks: SidebarNavItem[] = [
  {
    title: 'Products',
    items: [
      {
        href: '/products',
        icon: 'package',
        title: 'Products Catalog',
        authorizeOnly: UserRole.ADMIN,
        content: ProductCatalog,
        subItems: [
          {
            href: '/products/:id',
            title: 'Product Details',
            authorizeOnly: UserRole.ADMIN,
            content: ProductDetails,
            dynamic: true,
            hidden: true,
          },
          {
            href: '/products/additional-component-groups',
            title: 'Component Groups',
            authorizeOnly: UserRole.ADMIN,
            content: AdditionalComponentGroups,
          },
          {
            href: '/products/fabrics',
            title: 'Fabrics',
            authorizeOnly: UserRole.ADMIN,
            content: Fabrics,
          },

          {
            href: '/products/collections',
            title: 'Collections',
            authorizeOnly: UserRole.ADMIN,
            content: Collections,
          },
          {
            href: '/products/tags',
            title: 'Tags',
            authorizeOnly: UserRole.ADMIN,
            content: Tags,
          },
          {
            href: '/products/categories',
            title: 'Categories',
            authorizeOnly: UserRole.ADMIN,
            content: Categories,
          },
          {
            href: '/products/content-blocks',
            title: 'Content Blocks',
            authorizeOnly: UserRole.ADMIN,
            content: ContentBlocks,
          },
          {
            href: '/products/product-features',
            title: 'Product Features',
            authorizeOnly: UserRole.ADMIN,
            content: ProductFeatures,
          },
        ],
      },
    ],
  },
  {
    title: 'B2B',
    items: [
      {
        href: '/orders',
        icon: 'receipt',
        title: 'Orders',
        authorizeOnly: UserRole.ADMIN,
        content: Orders,
        subItems: [
          {
            href: '/orders/:orderId',
            title: 'Order Details',
            authorizeOnly: UserRole.ADMIN,
            content: OrderDetails,
            dynamic: true,
            hidden: true,
          },
        ],
      },
      {
        href: '/dashboard/b2b-accounts',
        icon: 'user',
        title: 'B2B Customers',
        authorizeOnly: UserRole.ADMIN,
        content: B2BCustomersTable,
        subItems: [
          {
            href: '/dashboard/b2b-accounts/groups',
            title: 'Groups',
            authorizeOnly: UserRole.ADMIN,
            content: CustomerGroups,
          },
          {
            href: '/dashboard/b2b-accounts/managers',
            title: 'Account Managers',
            authorizeOnly: UserRole.ADMIN,
            content: AccountManagers,
          },
          {
            href: '/dashboard/b2b-accounts/customer-accounts',
            title: 'Customer Accounts',
            authorizeOnly: UserRole.ADMIN,
            content: CustomerAccounts,
          },
          {
            href: '/dashboard/b2b-accounts/:accountId/orders',
            title: 'Account Orders',
            authorizeOnly: UserRole.ADMIN,
            content: B2BAccountOrdersPage,
            dynamic: true,
            hidden: true,
          },
          {
            href: '/products/fabric-palettes',
            title: 'Fabric Palettes',
            authorizeOnly: UserRole.ADMIN,
            content: FabricPalettes,
          },
          {
            href: '/dashboard/b2b-accounts/price-lists',
            title: 'Price Lists',
            authorizeOnly: UserRole.ADMIN,
            content: PriceLists,
            subItems: [
              {
                href: '/dashboard/b2b-accounts/price-lists/:id',
                title: 'Price List Details',
                authorizeOnly: UserRole.ADMIN,
                content: PriceListDetails,
                dynamic: true,
              },
            ],
          },
        ],
      },
    ],
  },
  {
    title: 'Settings',
    items: [
      // {
      //   href: "/organization",
      //   title: "Organization",
      //   icon: "home",
      //   authorizeOnly: UserRole.ADMIN,
      //   content: Organization,
      //   subItems: [
      {
        href: '/settings',
        icon: 'settings',
        title: 'Settings',
        content: Settings,
        authorizeOnly: UserRole.ADMIN,
        subItems: [
          {
            href: '/settings/ui',
            title: 'UI Settings',
            authorizeOnly: UserRole.ADMIN,
            content: UISettings,
            hidden: true,
          },
          {
            href: '/settings/translations',
            title: 'Emails',
            authorizeOnly: UserRole.ADMIN,
            content: Translations,
            hidden: true,
          },
          {
            href: '/settings/login-attempts',
            title: 'Login Attempts',
            authorizeOnly: UserRole.ADMIN,
            content: LoginAttempts,
            hidden: true,
          },
          {
            href: '/settings/languages',
            title: 'Language Settings',
            authorizeOnly: UserRole.ADMIN,
            content: LanguageSettings,
            hidden: true,
          },
          {
            href: '/settings/admin',
            title: 'Admin Settings',
            authorizeOnly: UserRole.ADMIN,
            content: AdminSettings,
            hidden: true,
          },
        ],
      },
      {
        href: '/organization/members',
        icon: 'laptop',
        title: 'Members',
        content: Members,
        authorizeOnly: UserRole.ADMIN,
      },
      // ],
      // },
    ],
  },
]

export const routerLinks = () => {
  const links: { path: string; role: any; content: any }[] = []

  const processItems = (items: NavItem[]) => {
    items.forEach(item => {
      links.push({
        path: item.href,
        role: item.authorizeOnly,
        content: item.content,
      })
      if (item.subItems) {
        processItems(item.subItems)
      }
    })
  }

  sidebarLinks.forEach(section => {
    processItems(section.items)
  })

  return links
}
